import { useRef, useState } from "react";
import { UnsavedChangesContext } from ".";
import { ErrorBoundary2 } from "@/pages/ErrorBoundary2";

type UnsavedChangesProviderProps = { children: React.ReactNode };
export function UnsavedChangesProvider({ children }: UnsavedChangesProviderProps) {
    const unsavedChanges = useRef<Set<unknown>>(new Set());
    const [hasUnsavedChanges, setHasUnsavedChanges] = useState(false);
    const markAsDirty = (obj: unknown) => {
        // console.log("markAsDirty", obj);
        unsavedChanges.current.add(obj);
        if (unsavedChanges.current.size === 1) setHasUnsavedChanges(true);
    };
    const markAsClean = (obj: unknown) => {
        // console.log("markAsClean", obj);
        unsavedChanges.current.delete(obj);
        if (unsavedChanges.current.size === 0) setHasUnsavedChanges(false);
    };
    const isDirty = (obj: unknown) => unsavedChanges.current.has(obj);
    const discardConfirmation = () => confirm("Du har osparade ändringar. Vill du stänga utan att spara?");

    return (
        <UnsavedChangesContext.Provider value={{
            unsavedChanges: hasUnsavedChanges,
            markAsDirty,
            markAsClean,
            isDirty,
            discardConfirmation,
        }}>
            <ErrorBoundary2 msg="UnsavedChangesProvider Inner">
                {children}
            </ErrorBoundary2>
        </UnsavedChangesContext.Provider>
    );
}